/**
 * Public configuration (URLs, environment names). Do NOT put secrets here — the web bundle is fully exposed.
 *
 * Priority order:
 * 1. `EXPO_PUBLIC_*` (embedded directly in the bundle)
 * 2. `react-native-config` (native / dev client, reads from .env)
 * 3. `expo.extra` in app.config.js — mapped from `.env` (e.g., FIREBASE_CLOUD_FUNCTION_URL, …) so web can share the same source as native
 */
import Constants from 'expo-constants';
import Config from 'react-native-config';

type ExtraKey = 'firebaseCloudFunctionUrl' | 'pictureUrl' | 'pinUrl' | 'environment' | 'sentryDsn';

function readConfig(key: keyof typeof Config): string | undefined {
  const raw = Config[key];
  if (typeof raw !== 'string') return undefined;
  const v = raw.trim();
  return v === '' ? undefined : v;
}

function readLegacy(key: string): string | undefined {
  const raw = (Config as Record<string, string | undefined>)[key];
  if (typeof raw !== 'string') return undefined;
  const v = raw.trim();
  return v === '' ? undefined : v;
}

function readExpoExtra(key: ExtraKey): string | undefined {
  const extra = Constants.expoConfig?.extra as Record<string, string | undefined> | undefined;
  const raw = extra?.[key];
  if (typeof raw !== 'string') return undefined;
  const v = raw.trim();
  return v === '' ? undefined : v;
}

export const envPublic = {
  get environment(): string {
    return readConfig('ENVIRONMENT') ?? readLegacy('ENV') ?? '';
  },

  get firebaseCloudFunctionUrl(): string {
    return (
      readConfig('FIREBASE_CLOUD_FUNCTION_URL') ?? readExpoExtra('firebaseCloudFunctionUrl') ?? ''
    );
  },

  get pictureUrl(): string {
    return readConfig('PICTURE_URL') ?? readExpoExtra('pictureUrl') ?? '';
  },

  get pinUrl(): string {
    return readConfig('PIN_URL') ?? readExpoExtra('pinUrl') ?? '';
  },

  get sentryDsn(): string {
    return readConfig('SENTRY_DSN') ?? readExpoExtra('sentryDsn') ?? '';
  },
} as const;

export function warnIfMissingCloudFunctionUrlInDev(): void {
  if (__DEV__ && !envPublic.firebaseCloudFunctionUrl) {
    console.warn(
      '[envPublic] Missing Cloud Functions URL. Add FIREBASE_CLOUD_FUNCTION_URL to .env (and restart Metro), or set it in extra within app.config.js',
    );
  }
}
